import { Layout, Button } from "antd";
import { FaBars, FaSignOutAlt } from "react-icons/fa";
import { Message } from "@/frontend/components/common";
import { useAuthStore } from "@/frontend/stores";
import { useNavigate } from "react-router-dom";
import { authService } from "@/frontend/services";
import type { ApiResponse } from "@/shared";

const { Header } = Layout;

interface NavbarProps {
  onCollapse?: () => void;
  title?: string;
}

export function Navbar({
  onCollapse,
  title = "Plataforma de Torneos",
}: NavbarProps) {
  const { user, logout, refreshToken } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const response: ApiResponse<void> = await authService.logout(
        refreshToken!,
      );

      if (response.success) {
        logout();
        navigate("/login");
      } else {
        Message.error({ content: response.error, duration: 5 });
      }
    } catch (error) {
      console.error(error);
      Message.error({ content: "Error al cerrar sesión", duration: 5 });
    }
  };

  return (
    <Header
      className="flex items-center justify-between sticky top-0 z-50 bg-white border-b border-slate-200 shadow-sm px-6"
      style={{
        height: "64px",
        paddingInline: "24px",
        backgroundColor: "#ffffff",
        lineHeight: "normal",
      }}
    >
      {/* Left side: Breadcrumbs / Title */}
      <div className="flex items-center gap-4">
        {onCollapse && (
          <Button
            type="text"
            onClick={onCollapse}
            className="lg:hidden text-slate-500 hover:text-slate-800"
          >
            <FaBars className="text-xl" />
          </Button>
        )}
        <div className="flex flex-col justify-center">
          <span className="text-[10px] text-slate-400 font-bold uppercase tracking-widest leading-none mb-1">
            Dashboard
          </span>
          <h1 className="text-xl font-bold text-slate-800 leading-none">
            {title}
          </h1>
        </div>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-3">
          {user?.fullName && (
            <span className="text-sm font-medium text-slate-600 hidden sm:block">
              {user.fullName}
            </span>
          )}

          <div className="h-9 w-9 rounded-full bg-slate-100 flex items-center justify-center border border-slate-200 text-slate-600 font-semibold text-sm">
            {user?.fullName?.charAt(0) || "U"}
          </div>

          <button
            onClick={handleLogout}
            className="text-slate-400 hover:text-red-500 transition-colors duration-200 ml-2"
            title="Sign Out"
          >
            <FaSignOutAlt className="text-lg" />
          </button>
        </div>
      </div>
    </Header>
  );
}
